import { Component, Input } from '@angular/core';
import { IMenuItem } from './menu-item.interface';

@Component({
  selector: 'upsc-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu-horizontal.component.scss', './menu-vertical.component.scss'],
})
export class MenuComponent {
  @Input() menuItems: IMenuItem[];
  @Input() menuStyle: string;

  constructor() {
  }

  public hasChildMenu(menuItem: IMenuItem) {
    return !!menuItem.children && menuItem.children.length > 0;
  }

  public hasRouterLink(menuItem: IMenuItem) {
    return !!menuItem.routerLink;
  }

  public toggleMenu(event, menuItem: IMenuItem) {
    event.stopPropagation();

    this.menuItems.map(
      (item) => {
        // This closes other menu items but can cause unexpected menu item movement.
        // if (item !== menuItem) {
        //   item.isOpened = false;
        // }

        return item;
      },
    );

    menuItem.isOpened = !menuItem.isOpened;
  }
}
